module.exports = __webpack_public_path__ + "img/xz1c.2ebc425e.jpg";